<div
  class="centered-container top-gap "
  fxLayout="column"
  fxLayoutAlign="start center"
>
  <mat-card *ngIf="!loading" class="mat-elevation-z4">
    <mat-card-content fxLayout="column" fxLayoutAlign="start center">
      <div class="header">
        <span class="large-title center ">Your Details</span>
      </div>
      <form [formGroup]="formModel.formGroup" (ngSubmit)="save()">
        <div
          class="form-container-1"
          fxLayout="row"
          fxLayoutGap="12px"
          fxLayout="space-around start"
        >
          <mat-form-field fxFlex="100" fxFlex.gt-xs="calc(50%-12px)">
            <mat-label>First Name</mat-label>
            <input matInput formControlName="firstName" />
            <mat-error *ngFor="let validator of formModel.validators.firstName">
              <span
                *ngIf="
                  formModel.formGroup.controls.firstName.hasError(
                    validator.type
                  )
                "
              >
                {{ validator.message }}
              </span>
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="100" fxFlex.gt-xs="calc(50%-12px)">
            <mat-label>Last Name</mat-label>
            <input matInput formControlName="lastName" />
            <mat-error *ngFor="let validator of formModel.validators.lastName">
              <span
                *ngIf="
                  formModel.formGroup.controls.lastName.hasError(validator.type)
                "
              >
                {{ validator.message }}
              </span>
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="100" fxFlex.gt-xs="calc(50%-12px)">
            <mat-icon matSuffix>email</mat-icon>
            <mat-label>Email Address</mat-label>
            <input
              matInput
              type="email"
              formControlName="emailAddress"
            /><mat-error
              *ngFor="let validator of formModel.validators.emailAddress"
            >
              <span
                *ngIf="
                  formModel.formGroup.controls.emailAddress.hasError(
                    validator.type
                  )
                "
              >
                {{ validator.message }}
              </span>
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="100" fxFlex.gt-xs="calc(50%-12px)">
            <mat-label>Phone Number</mat-label>
            <span matPrefix>+27 &nbsp;</span>
            <mat-icon matSuffix>phone</mat-icon>
            <input matInput type="tel" formControlName="phoneNumber" />
            <mat-error
              *ngFor="let validator of formModel.validators.phoneNumber"
            >
              <span
                *ngIf="
                  formModel.formGroup.controls.phoneNumber.hasError(
                    validator.type
                  )
                "
              >
                {{ validator.message }}
              </span>
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="100" fxFlex.gt-xs="50">
            <mat-label>Date of Birth</mat-label>
            <input
              matInput
              formControlName="dateOfBirth"
              [matDatepicker]="dateOfBirth"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="dateOfBirth"
            ></mat-datepicker-toggle>
            <mat-datepicker #dateOfBirth></mat-datepicker>
          </mat-form-field>
        </div>
        <div
          class="form-container-2"
          fxLayout="row"
          fxLayoutAlign="center start"
        >
          <mat-checkbox
            formControlName="isServiceProvider"
            class="large-checkbox"
            labelPosition="before"
          >
            I am a service provider:
          </mat-checkbox>
        </div>
        <div
          class="form-container-3"
          fxLayoutGap.gt-xs="12px"
          fxLayout="row wrap"
          *ngIf="formModel.isServiceProvider"
        >
          <mat-form-field fxFlex="100" fxFlex.gt-xs="calc(50%-12px)">
            <mat-label>Address Line 1</mat-label>
            <input matInput formControlName="addressStreet1" />
            <mat-error
              *ngFor="let validator of formModel.validators.addressStreet1"
            >
              <span
                *ngIf="
                  formModel.formGroup.controls.addressStreet1.hasError(
                    validator.type
                  )
                "
              >
                {{ validator.message }}
              </span>
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="100" fxFlex.gt-xs="calc(50%-12px)">
            <mat-label>Address Line 2</mat-label>
            <input matInput formControlName="addressStreet2" />
          </mat-form-field>
          <mat-form-field fxFlex="100" fxFlex.gt-xs="calc(50%-12px)">
            <mat-label>City</mat-label>
            <input matInput formControlName="addressCity" />
            <mat-error
              *ngFor="let validator of formModel.validators.addressCity"
            >
              <span
                *ngIf="
                  formModel.formGroup.controls.addressCity.hasError(
                    validator.type
                  )
                "
              >
                {{ validator.message }}
              </span>
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="100" fxFlex.gt-xs="calc(50%-12px)">
            <mat-label>Postcode</mat-label>
            <input matInput formControlName="addressPostCode" />
            <mat-error
              *ngFor="let validator of formModel.validators.addressPostCode"
            >
              <span
                *ngIf="
                  formModel.formGroup.controls.addressPostCode.hasError(
                    validator.type
                  )
                "
              >
                {{ validator.message }}
              </span>
            </mat-error>
          </mat-form-field>
          <mat-radio-group
            class="rsaCitizenButtonGroup"
            formControlName="rsaCitizen"
            fxFlex="100"
            aria-label="Are you an RSA Citizen / Permenant Resident?"
          >
            <span class="radio-label"
              >Are you an RSA Citizen / Permenant Resident?</span
            >
            <mat-radio-button [value]="true">Yes</mat-radio-button>
            <mat-radio-button [value]="false">No</mat-radio-button>
          </mat-radio-group>
          <mat-form-field fxFlex="100" class="idNumberFormField">
            <mat-label>ID Number</mat-label>
            <input matInput formControlName="rsaIdNumber" />
            <mat-error
              *ngFor="let validator of formModel.validators.rsaIdNumber"
            >
              <span
                *ngIf="
                  formModel.formGroup.controls.rsaIdNumber.hasError(
                    validator.type
                  )
                "
              >
                {{ validator.message }}
              </span>
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="100">
            <mat-label>Passport Number</mat-label>
            <input matInput formControlName="passportNumber" />
            <mat-error
              *ngFor="let validator of formModel.validators.passportNumber"
            >
              <span
                *ngIf="
                  formModel.formGroup.controls.passportNumber.hasError(
                    validator.type
                  )
                "
              >
                {{ validator.message }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div>
          <button
            fxFlex="100"
            [class.spinner]="saving"
            [disabled]="saving"
            color="primary"
            mat-raised-button
          >
            <mat-icon>save</mat-icon>
            Save
          </button>
        </div>
      </form></mat-card-content
    ></mat-card
  >
  <app-loading-spinner [(show)]="loading"></app-loading-spinner>
</div>
